import { ReactNode } from 'react';
import classNames from 'classnames';

import { Button } from 'components-antd';
import { AddNew } from 'components/Icons';
import { Icons } from 'pages/Templates/Icons';

import styles from './styles.module.scss';

type EmptyStateType = {
  emptyText: string;
  icon: ReactNode;
  onAdd: () => void;
  onAddFromTemplate?: () => void;
  isTransparent?: boolean;
};

export const EmptyState = ({
  emptyText,
  icon,
  onAdd,
  onAddFromTemplate,
  isTransparent = false,
}: EmptyStateType) => {
  return (
    <div className={classNames(styles.emptyContainer, { [styles.transparent]: isTransparent })}>
      <div className={styles.icon}>{icon}</div>
      <p className={styles.text}>{emptyText}</p>
      {onAdd && (
        <Button variant="hollow-bordered" className={styles.addBtn} onClick={onAdd}>
          <AddNew /> Add New
        </Button>
      )}
      {onAddFromTemplate && (
        <Button
          variant="hollow-bordered"
          className={styles.templateBtn}
          onClick={onAddFromTemplate}
        >
          <Icons variant={Icons.FOLDER} /> Add From Templates
        </Button>
      )}
    </div>
  );
};
